import { ConfirmBeforeUnload } from '@eway-crm/gui';
import React from 'react';
import { isTerminalFinalizationStep } from '../../constants/FinalizationSteps';
import { getEwayObject } from '../../helpers/ewayObjectHelper';
import useFinalizationState from '../../pages/FinalizationPage/hooks/useFinalizationState';
import { FinalizationContext } from './FinalizationProvider';

const FinalizationUnloadGuard: React.FC = () => {
    const { finalization } = React.useContext(FinalizationContext);
    const { finalizationStep } = useFinalizationState();

    if (!finalization || isTerminalFinalizationStep(finalizationStep) || getEwayObject().isOutlookClient()) {
        return null;
    }

    return <ConfirmBeforeUnload />;
};

export default React.memo(FinalizationUnloadGuard);
